'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIcofont = require('react-icofont');

var _reactIcofont2 = _interopRequireDefault(_reactIcofont);

var _reactLazyLoadImageComponent = require('react-lazy-load-image-component');

var _emptyImg = require('../../../img/empty-img.png');

var _emptyImg2 = _interopRequireDefault(_emptyImg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CardItem = function (_React$Component) {
    _inherits(CardItem, _React$Component);

    function CardItem() {
        _classCallCheck(this, CardItem);

        return _possibleConstructorReturn(this, (CardItem.__proto__ || Object.getPrototypeOf(CardItem)).apply(this, arguments));
    }

    _createClass(CardItem, [{
        key: 'handleItemClick',
        value: function handleItemClick(e) {
            event.preventDefault();
            this.props.callBackParent();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'a',
                { role: 'button', href: '#', className: 'menuAnchortag', onClick: function onClick(event) {
                        return _this2.handleItemClick(event);
                    }, tabIndex: 10 },
                _react2.default.createElement(
                    'div',
                    {
                        className: 'list-card bg-white h-100 rounded overflow-hidden position-relative shadow-sm'
                        // onKeyDown={this.onKeyDown.bind(this)}
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'list-card-image' },
                        _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
                            src: this.props.itemImageURL,
                            placeholderSrc: _emptyImg2.default,
                            className: this.props.imageClassName
                            // width={600} height={400}
                            , alt: this.props.imageAlt
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'p-3 position-relative' },
                        _react2.default.createElement(
                            'div',
                            { className: 'list-card-body' },
                            _react2.default.createElement(
                                'h6',
                                { className: 'font-weight-bold' },
                                this.props.title
                            ),
                            this.props.subTitle ? _react2.default.createElement(
                                'p',
                                { className: 'card-text mb-2' },
                                this.props.subTitle
                            ) : '',
                            _react2.default.createElement(
                                'p',
                                { className: 'mb-0 ft-14' },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'color-styl' },
                                    '$',
                                    this.props.price
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return CardItem;
}(_react2.default.Component);

exports.default = CardItem;


//////////////////
// WEBPACK FOOTER
// ./src/components/common/CardItem.jsx
// module id = 501
// module chunks = 0